import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { API_BASE } from '../config';
import './AnnouncementsSection.css';

const AnnouncementsSection = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/announcements`)
      .then(res => res.json())
      .then(data => setAnnouncements(data))
      .catch(() => {});
  }, []);

  if (announcements.length === 0) return null;

  return (
    <section className="announcements-section">
      <div className="announcements-container">
        <div className="announcements-header">
          <div className="announcements-header-left">
            <span className="announcements-subtitle">Güncel</span>
            <h2 className="announcements-title">Duyurular</h2>
          </div>
          <Link to="/duyurular" className="announcements-all-btn">
            Tümünü Gör <FaArrowRight />
          </Link>
        </div>

        <div className="announcements-grid">
          {/* Featured - İlk duyuru büyük */}
          <Link to={`/${announcements[0].slug}`} className="ann-card ann-card--featured">
            <div className="ann-card-image">
              <img src={announcements[0].image} alt={announcements[0].title} />
              <div className="ann-card-image-overlay"></div>
              <span className="ann-card-category">{announcements[0].category}</span>
            </div>
            <div className="ann-card-content">
              <div className="ann-card-date">
                <FaCalendarAlt />
                <span>{announcements[0].date}</span>
              </div>
              <h3 className="ann-card-title">{announcements[0].title}</h3>
              <p className="ann-card-summary">{announcements[0].summary}</p>
              <span className="ann-card-read">
                Devamını Oku <FaArrowRight />
              </span>
            </div>
          </Link>

          {/* Diğer duyurular - sağda liste */}
          {announcements.length > 1 && (
            <div className="ann-list">
              {announcements.slice(1, 5).map((ann) => (
                <Link to={`/${ann.slug}`} className="ann-list-item" key={ann._id}>
                  <div className="ann-list-image">
                    <img src={ann.image} alt={ann.title} />
                  </div>
                  <div className="ann-list-content">
                    <span className="ann-list-category">{ann.category}</span>
                    <h4 className="ann-list-title">{ann.title}</h4>
                    <div className="ann-list-date">
                      <FaCalendarAlt />
                      <span>{ann.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AnnouncementsSection;
